import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink, LifeBuoy, Phone } from "lucide-react";

/**
 * Reusable closing CTA block used in several pages.
 */
export default function HelpCta({
  title = "No estás solo. Hay ayuda profesional disponible.",
  subtitle = "Red SinAdicciones.org — la plataforma más completa de Chile para encontrar centros, profesionales y tratamiento.",
  testidPrefix = "cta",
}) {
  return (
    <section
      data-testid={`${testidPrefix}-help-block`}
      className="relative overflow-hidden rounded-3xl border border-slate-800 bg-gradient-to-br from-slate-900 via-slate-900 to-slate-950 p-8 sm:p-12"
    >
      <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-red-500/10 blur-3xl" />
      <div className="relative">
        <h2 className="max-w-2xl text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
          {title}
        </h2>
        <p className="mt-3 max-w-2xl text-sm text-slate-400 sm:text-base">{subtitle}</p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <a
            href="https://sinadicciones.org/centros-de-rehabilitacion-drogas-chile"
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testidPrefix}-centros-btn`}
            className="btn-press inline-flex items-center gap-2 rounded-full bg-red-500 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-red-500/20 hover:bg-red-600"
          >
            <LifeBuoy className="h-4 w-4" />
            Buscar Centros de Rehabilitación
            <ExternalLink className="h-3.5 w-3.5 opacity-70" />
          </a>
          <a
            href="https://sinadicciones.org/profesionales"
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testidPrefix}-profesionales-btn`}
            className="btn-press inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900 px-6 py-3 text-sm font-semibold text-slate-100 hover:bg-slate-800"
          >
            Hablar con un Profesional
            <ArrowRight className="h-4 w-4" />
          </a>
          <Link
            to="/test-dependencia"
            className="btn-press inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-6 py-3 text-sm font-semibold text-emerald-300 hover:bg-emerald-500/15"
          >
            Hacer Test de Dependencia
          </Link>
        </div>

        <div className="mt-8 flex items-center gap-2 text-sm text-slate-400">
          <Phone className="h-4 w-4 text-red-400" />
          <span>
            Fono Drogas SENDA:{" "}
            <a href="tel:1412" className="font-semibold text-slate-100 hover:text-emerald-400">
              1412
            </a>{" "}
            <span className="text-slate-500">(24/7, gratuito)</span>
          </span>
        </div>
      </div>
    </section>
  );
}
